import { render, staticRenderFns } from "./TabelaPessoasPorEquipe.vue?vue&type=template&id=337d9aa8&scoped=true"
import script from "./TabelaPessoasPorEquipe.vue?vue&type=script&lang=js"
export * from "./TabelaPessoasPorEquipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337d9aa8",
  null
  
)

export default component.exports